import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortUp, faSortDown, faEllipsisV, faTimes ,faPlus , faCheckCircle,faSearch } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import {Loader, Spinner } from '../BBAdmin/Loader/Loader';
import { Msg200or201, Msg204, Msg400, Msg401 ,Msg403, Msg500 } from './Messages/Messages';
import ProjectReports from '../measurit/ProjectSummary/ProjectReports';
import * as XLSX from 'xlsx';
import Pagination, { usePagination } from '../BBAdmin/Components/Pagination';
import Search from '../BBAdmin/Components/Search';
import { decryptData } from '../utils/storageCrypto';


const ProjectList = () => {
      const eri = sessionStorage.getItem('roleId');
    const roleId = decryptData(eri)?.toString();
    console.log(typeof(roleId))
  const [projects, setProjects] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: '', direction: '' });
  const navigate = useNavigate();
  const [isSaving , setisSaving] = useState(false);
  const [isMeasurementsNotify, setMeasurementsNotify] = useState(false); 
  const [isAdvancePaymentNotify, setAdvancePaymentNotify] = useState(false); 
  const [isProductionMeasurementsNotify, setProductionMeasurementsNotify] = useState(false); 
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [popupType, setPopupType] = useState('');
  const [errorMessages, setErrorMessages] = useState([]);
  const RETRY_LIMIT = 3; // Maximum number of retries
  const [retryCount, setRetryCount] = useState(0); // Track retry attempts
  const [retryFunction, setRetryFunction] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const backendApiUrl = process.env.REACT_APP_FORE_APILINK;

    const encryptedOrganizationId = sessionStorage.getItem('organizationId');
    const organizationId = decryptData(encryptedOrganizationId);
  const GetUsers = process.env.REACT_APP_FORE_APILINK + `/admin/get-all-users-details?organizationId=${organizationId}`;
  const AssignMAToProject = process.env.REACT_APP_FORE_APILINK + '/admin/assign-project-to-marketingassociate';
  const AssignFAToProject = process.env.REACT_APP_FORE_APILINK + '/admin/assign-project-to-fieldassociate';
  const url = process.env.REACT_APP_FORE_APILINK + `/projects/update-project?projectId=${selectedProjectId}`;
  const [users, setUsers] = useState([]);
  const [ProjectUserId, setProjectUserId] = useState();
  const [AssignMarketingAssociate, setAssignUser] = useState(false);
  const [AssignFieldAssociate, setAssignFieldAssociate] = useState(false);
  const [UserAssignedtoProjectAlert, setUserAssignedtoProjectAlert] = useState(false);
  const [noSelectAssignUseralert, setnoSelectAssignUseralert] = useState(false);
  const [selectedproject, setselectedproject] = useState();
  const [selectedUser, setselectedUser] = useState();
  const [rescheduleDate, setRescheduleDate] = useState({});
  const [DatePopup, setDatePopup] = useState(false);
  const [CollectPopUp , setCollectPopUp] = useState(false);
  const [NotifyPopUp , setNotifyPopUp] = useState(false);
  const [displayedProjects, setdisplayedProjects] = useState([]);
  const [currentProject ,setcurrentProject] = useState();
  const [date,setDate] = useState('');
     const [purposeOfVisit, setPurposeOfVisit] = useState('');
    const [showSummaryPopup, setShowSummaryPopup] = useState(false);
    const [selectedProject, setSelectedProject] = useState(null);
   // console.log(selectedProject);
    const [measurementStatus, setMeasurementStatus] = useState({
      quotation: selectedProject?.quotationMeasurementStatus,
      production: selectedProject?.productionMeasurementStatus
    });

    const [showPurposePopup, setShowPurposePopup] = useState(false);
const [selectedPurpose, setSelectedPurpose] = useState('');
const [quoteSummary , setQuoteSummary]= useState(false)
const [productionSummary , setProductionSummary]= useState(false)

const [completedStatus, setCompletedStatus] = useState({
  quotation: selectedProject?.quotationMeasurementStatus === 'Completed',
  production: selectedProject?.productionMeasurementStatus === 'Completed'
});
const [showOrderTypePopup, setShowOrderTypePopup] = useState(false);
const [orderData, setOrderData] = useState(null);
const [showQuoteCategoryPopup, setShowQuoteCategoryPopup] = useState(false);
const [selectedQuoteCategory, setSelectedQuoteCategory] = useState('all');
const [selectedQuoteType,setSelectedQuoteType] = useState('whole_project')
const [isGenerating, setIsGenerating] = useState(false);
const [isRefreshing, setIsRefreshing] = useState(false);
const [showData, setShowData] = useState(false);
const searchTypes = ['Project Name', 'Builder Name', 'Stage of Construction'];

const [persistedSearchQuery, setPersistedSearchQuery] = useState('');
const [persistedSearchType, setPersistedSearchType] = useState('');

const [filteredProjects, setFilteredProjects] = useState([]);

const [searchChips, setSearchChips] = useState(() => {
  const saved = localStorage.getItem('projectSearchChips');
  return saved ? JSON.parse(saved) : [];
});


useEffect(() => {
  localStorage.setItem('projectSearchChips', JSON.stringify(searchChips));
}, [searchChips]);


const {
  currentItems,
  currentPage,
  totalPages,
  totalItems,
  itemsPerPage,
  handlePageChange,
  handlePreviousPage,
  handleNextPage,
  resetToFirstPage
} = usePagination(displayedProjects, 10);


  const sortArray = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });

    const sortedArray = [...projects].sort((a, b) => {
      const aValue = a[key] || ''; // Treat undefined as empty string
      const bValue = b[key] || ''; // Treat undefined as empty string

      // Convert to string for comparison and handle case insensitivity
      const aString = aValue.toString().toLowerCase();
      const bString = bValue.toString().toLowerCase();

      if (aString < bString) {
        return direction === 'ascending' ? -1 : 1;
      }
      if (aString > bString) {
        return direction === 'ascending' ? 1 : -1;
      }
      return 0;
    });

    setProjects(sortedArray);
    resetToFirstPage();
  };

  const getSortIcon = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'ascending' ? <FontAwesomeIcon icon={faSortUp} /> : <FontAwesomeIcon icon={faSortDown} />;
    }
    return null;
  };

  const enuserData = sessionStorage.getItem('userData');
  const userData = decryptData(enuserData)

  const filterProjects = (projects) => {
    if (!userData || (userData.roleID !== 2 && userData.roleID !== 3)) {
      return projects;
    }

    return projects.filter(project => {
      if (userData.roleID === 2) {
        return project.marketingAssociateId === userData.userId;
      } else if (userData.roleID === 3) {
        return project.fieldAssociateId === userData.userId;
      }
    });
  };


 const handleSearch = (query, type) => {
  const q = (query || '').toLowerCase().trim();

  if (!q || !type) {
    setdisplayedProjects(projects);
    resetToFirstPage();
    return;
  }

  const filtered = projects.filter((project) => {
    switch (type) {
      case 'Project Name':
        return project.projectName?.toLowerCase().includes(q);

      case 'Builder Name':
        return project.builderName?.toLowerCase().includes(q);

      case 'Stage of Construction':
        return project.stageofconstruction?.toLowerCase().includes(q);

      default:
        return true;
    }
  });

  setdisplayedProjects(filtered);
  resetToFirstPage();
};


  const handleRemoveSearchChip = (chipToRemove) => {
  const updated = searchChips.filter(
    (chip) =>
      !(chip.query === chipToRemove.query && chip.type === chipToRemove.type)
  );
setSearchChips(updated);
  localStorage.setItem('projectSearchChips', JSON.stringify(updated));  if (updated.length === 0) {
    setdisplayedProjects(projects);
    setPersistedSearchQuery('');
    setPersistedSearchType('');
    return;
  }
  const last = updated[updated.length - 1];
  handleSearch(last.query, last.type);
};


const handleAddSearchChip = (query, type) => {
  if (!type) return;

  const actualQuery = query.trim();

  setSearchChips((prev) => {
    const exists = prev.some(
      (chip) => chip.query === actualQuery && chip.type === type
    );
    if (exists) return prev;

     const updated = [...prev, { query: actualQuery, type }];
    localStorage.setItem('projectSearchChips', JSON.stringify(updated));
    return updated;
  });

  setPersistedSearchQuery(actualQuery);
  setPersistedSearchType(type);
  handleSearch(actualQuery, type);
};


const handleChipClick = (chip) => {
  setPersistedSearchQuery(chip.query);
  setPersistedSearchType(chip.type);
  handleSearch(chip.query, chip.type);
};

  const fetchProjects = async (attempt = 1) => {
    setIsLoading(true);
  
    try {
      const encryptedToken = sessionStorage.getItem('token');
              const token = decryptData(encryptedToken);
              const encryptedOrganizationId = sessionStorage.getItem('organizationId');
              const organizationId = decryptData(encryptedOrganizationId);
      const GetProjects = `${backendApiUrl}/projects/get-all-projects?organizationId=${organizationId}`;
      
      const response = await fetch(GetProjects, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'x-token': token
        },
      });
  
      const data = await response.json();
  
      if (response.ok) {
        const projectsData = data;
        const filteredProjects = filterProjects(data);
        setProjects(filteredProjects);
        //console.log(data);
        setIsLoading(false);
        setdisplayedProjects(filteredProjects || []);
        return data;
      
      } else if (response.status === 500) {
        setShowPopup(true);
        setRetryFunction(() => () => fetchProjects());
        setPopupType("500");
        setPopupMessage(data.message || "Internal Server Error");
        setIsLoading(false);
      } else {
        setPopupMessage(data.message || "Failed to fetch projects");
        setPopupType(`${response.status}`);
        setShowPopup(true);
        setIsLoading(false);
      }
    } catch (error) {
      console.error('Failed to fetch projects:', error);
  
      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1);
        setTimeout(() => fetchProjects(attempt + 1), 1000);
        setIsLoading(false)
      } else {
        setIsLoading(false);
        setPopupMessage("Internal Server Error. Kindly Retry.");
        setPopupType("500");
        setShowPopup(true);
        setRetryFunction(() => () => fetchProjects(attempt));
      }
    }
  
    return [];
  };

  useEffect(() => {
    fetchProjects(); 
    fetchUsers();
    
    const handleRefresh = () => {
      fetchProjects(); 
    };
    window.addEventListener('refreshProjectList', handleRefresh);
    return () => {
      window.removeEventListener('refreshProjectList', handleRefresh);
    };
  }, []);
  





      const closePopup = () => {
       // console.log("closePopup called");
        setShowPopup(false);
      };

      const Retry = async () => {
        //console.log("Retry called");
        setIsLoading(true); // Show loader
        setTimeout(async () => {
          if (retryFunction) {
            await retryFunction();
          }
          setIsLoading(false); // Hide loader after retry
        }, 5000); // 5-second delay
        setShowPopup(false);
      };
      
      const BackToLoginPage = () => {
        //console.log("Back To Login Page");
        setShowPopup(false);
        localStorage.removeItem('LoginData');
        sessionStorage.removeItem('userData');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('userId');
        sessionStorage.removeItem('appId');
      navigate('/bb');
      };

      
      

  const handleNavigateProjectDetails = (project)=>{
    // console.log(project)
    navigate('/bb/app/projects/projectdetails', {state:{projectData: project}} );
  }

  const handleNavigatetoMeasurements = (project, measurementsType) => {
    if (!project || !measurementsType) {
      console.error('Invalid project or measurementsType');
      return;
    }
  
    const data = {
      projectData: project,
      measurementsType: measurementsType,
    };
  
    navigate('/bb/app/projects/measurements', { state: { projectData: data } });
  };

  const handleNewProject = () => {
    navigate('/bb/app/projects/newproject');
  };

  const fetchUsers = async () => {         
    try{
     const encryptedToken = sessionStorage.getItem('token');
             const token = decryptData(encryptedToken);

      const response = await fetch(GetUsers,{
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json', // Set the content type to JSON
          'x-token':token
        },
      })
      if(response.ok){
        const usersData = await response.json();
        setUsers(usersData);
       // console.log(usersData);
        fetchProjects();
      }
      else {
      }
    }
    catch (error){
    }
  };
  
  const handleAssignprojecttoMarketingAssociate = async(user) => {      
    const selectedUsers = users.filter((user) => user.isSelected);
    if (selectedUsers.length === 0) {
     setnoSelectAssignUseralert(true);
      return;
    }
    const userId = selectedUsers.map((user) => user._id);

    const data = {
      projectId: selectedproject._id,
      userId: userId
    };
    try {
      const encryptedToken = sessionStorage.getItem('token');
              const token = decryptData(encryptedToken);

      const response = await fetch(AssignMAToProject,{
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json', // Set the content type to JSON
        'x-token':token
      },

      body: JSON.stringify(data),
    })
     if (response.ok) {
      setselectedUser(user);
      setAssignUser(false);
      setAssignFieldAssociate(false);
      setUserAssignedtoProjectAlert(true);
      
      //alert('Users assigned to project successfully');

    } else {
    }
  } catch (error) {
  }
};

  const handleAssignprojecttoFieldAssociate = async(user) => {      
    const selectedUsers = users.filter((user) => user.isSelected);
    if (selectedUsers.length === 0) {
     setnoSelectAssignUseralert(true);
      return;
    }
    const userId = selectedUsers.map((user) => user._id);

    const data = {
      projectId: selectedproject._id,
      userId: userId
    };
    try {
      const encryptedToken = sessionStorage.getItem('token');
              const token = decryptData(encryptedToken);

      const response = await fetch(AssignFAToProject,{
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json', // Set the content type to JSON
        'x-token':token
      },

      body: JSON.stringify(data),
    })
     if (response.ok) {
      setselectedUser(user);
      setAssignUser(false);
      setAssignFieldAssociate(false);
      setUserAssignedtoProjectAlert(true);
      
      //alert('Users assigned to project successfully');

    } else {
    }
  } catch (error) {
  }
};

const handleCheckboxChange = (userId) => {
  setProjectUserId(userId)
  setUsers((prevUsers) =>
    prevUsers.map((User) =>
    User._id === userId ? { ...User, isSelected: !User.isSelected } : User
    )
  );
};

  const handleAssignMarketingAssociate = async(Project)=>{
    setAssignUser(true);
    setselectedproject(Project);
    setProjectUserId(Project.marketingAssociateId);
   };

   const handleAssignFieldAssociate = async(Project)=>{
    setAssignFieldAssociate(true);
    setselectedproject(Project);
    setProjectUserId(Project.fieldAssociateId);
   };

   const handleClose = () => {
     setAssignUser(false);
     setAssignFieldAssociate(false);
     setCollectPopUp(false);
     setNotifyPopUp(false);
     setShowPurposePopup(false);
   }

   const handleClosenoAssigneUser = () =>{
    setnoSelectAssignUseralert(false);
  }

   const handleUserAssignedtoProjectAlert = async () => {
    setUserAssignedtoProjectAlert(false);
    window.location.reload();
   }

   const handleCloseDate = () => {
    setDatePopup(false);
   // window.location.reload();
  };

  const handleDateChange = (e) => {
    const selectedDate = e.target.value;
    setDate(selectedDate);
    // Set only the selected date for the specified project ID
    setRescheduleDate(selectedDate);
  };

  const handlePurposeChange = (e) => {
    setPurposeOfVisit(e.target.value);
  };

  const handleSubmit = async () => {
    setisSaving(true);
    try {
      const encryptedToken = sessionStorage.getItem('token');
              const token = decryptData(encryptedToken);

      const date = rescheduleDate;
      //console.log(date);
  
      const formData = new FormData();
      formData.append('rescheduleDate', date);
      formData.append('purposeOfVisit', purposeOfVisit);
  
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'x-token': token
        },
        body: formData
      });
  
      const data = await response.json();
      //console.log(data);
      setDatePopup(false);
      setProjects(prevProjects => 
        prevProjects.map(project => 
          project._id === selectedProjectId 
            ? { ...project, rescheduleDate: date, purposeOfVisit: purposeOfVisit }
            : project
        )
      );
      
    const statusMessages = {
      400: 'Bad Request',
      401: 'Unauthorized',
      403: 'Forbidden',
      404: 'Project not found',
      500: 'Internal Server Error'
    };

    setMeasurementsNotify(false);
    setCollectPopUp(false);
    
    if (response.ok) {
      setPopupMessage('email sent successfully');
      setPopupType('200or201');
    } else {
      setPopupMessage(data.message || statusMessages[data.status] || 'An unexpected error occurred');
      setPopupType(data.status.toString());
    }
    
    setShowPopup(true);
    
    if (response.ok) {
      setTimeout(() => {
        setShowPopup(false);
        setPopupMessage('');
        setPopupType('');
      }, 2000);
    }
    } catch (error) {
      console.error('Error rescheduling project:', error);
      setPopupMessage('Failed to reschedule project');
      setPopupType('500');
      setShowPopup(true);
    } finally {
      setisSaving(false);
    }
  };
  

  const handleOpenDate = (projectId,date,pov) => {
    //console.log(projectId)
   // console.log(date)
    setDatePopup(true);
    setDate(date); 
    setPurposeOfVisit(pov);
    setSelectedProjectId(projectId);
  };

const handleCollect = async (project) => {
  setCollectPopUp(true);
  setcurrentProject(project);
};
    const handleCollectMeasurements = async (project) => {
      setMeasurementsNotify(true);
      try {
        const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

        const response = await fetch(`${backendApiUrl}/admin/send-collect-measurements-notification-to-field-associate`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token
          },
          body: JSON.stringify({
            projectId: project._id,
            projectName: project.projectName,
            fieldAssociateId: project.fieldAssociateId
          })
        });
        const data = await response.json();
        //(data);

        const statusMessages = {
          200: 'Success',
          400: 'Bad Request',
          401: 'Unauthorized',
          403: 'Forbidden',
          404: 'Not Found',
          500: 'Internal Server Error'
        };

        setCollectPopUp(false);
        setPopupMessage(data.message || statusMessages[data.status] || 'An unexpected error occurred');
        setPopupType(data.status === 200 ? '200or201' : data.status.toString());
        setShowPopup(true);

        if (data.status === 200) {
          setTimeout(() => {
            setShowPopup(false);
            setPopupMessage('');
            setPopupType('');
          }, 2000);
        }
      } catch (error) {
        console.error('Error sending notification:', error);
        setPopupMessage('Failed to send notification');
        setPopupType('500');
        setShowPopup(true);
      } finally {
        setMeasurementsNotify(false);
      }
    };

    
  const handleCollectAdvancePayment = async (project) => {
    setAdvancePaymentNotify(true);
    try {
      const encryptedToken = sessionStorage.getItem('token');
              const token = decryptData(encryptedToken);

      const response = await fetch(`${backendApiUrl}/admin/send-collect-advance-payment-notification-to-field-associate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        },
        body: JSON.stringify({
          projectId: project._id,
          projectName: project.projectName,
          fieldAssociateId: project.fieldAssociateId
        })
      });
      const data = await response.json();
      //console.log(data);

      const statusMessages = {
        200: 'Success',
        400: 'Bad Request',
        401: 'Unauthorized',
        403: 'Forbidden',
        404: 'Not Found',
        500: 'Internal Server Error'
      };
      setCollectPopUp(false);
      setPopupMessage(data.message || statusMessages[data.status] || 'An unexpected error occurred');
      setPopupType(data.status === 200 ? '200or201' : data.status.toString());
      setShowPopup(true);

      if (data.status === 200) {
        setTimeout(() => {
          setShowPopup(false);
          setPopupMessage('');
          setPopupType('');
        }, 2000);
      }
    } catch (error) {
      console.error('Error sending notification:', error);
      setPopupMessage('Failed to send notification');
      setPopupType('400');
      setShowPopup(true);
    }finally{
      setAdvancePaymentNotify(false);
    }
  };

  const handleCollectProductionMeasurements = async (project) => {
    setProductionMeasurementsNotify(true);
    try {
      const encryptedToken = sessionStorage.getItem('token');
              const token = decryptData(encryptedToken);

      const response = await fetch(`${backendApiUrl}/admin/send-collect-production-measurements-notification-to-field-associate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        },
        body: JSON.stringify({
          projectId: project._id,
          projectName: project.projectName,
          fieldAssociateId: project.fieldAssociateId
        })
      });
      const data = await response.json();
      //console.log(data);

      const statusMessages = {
        200: 'Success',
        400: 'Bad Request',
        401: 'Unauthorized',
        403: 'Forbidden',
        404: 'Not Found',
        500: 'Internal Server Error'
      };
      setCollectPopUp(false);
      setPopupMessage(data.message || statusMessages[data.status] || 'An unexpected error occurred');
      setPopupType(data.status === 200 ? '200or201' : data.status.toString());
      setShowPopup(true);

      if (data.status === 200) {
        setTimeout(() => {
          setShowPopup(false);
          setPopupMessage('');
          setPopupType('');
        }, 2000);
      }
    } catch (error) {
      console.error('Error sending notification:', error);
      setPopupMessage('Failed to send notification');
      setPopupType('400');
      setShowPopup(true);
    }finally {
      setProductionMeasurementsNotify(false);
    }
  };

  const handleNotify = async (project) => {
    setNotifyPopUp(true);
    setcurrentProject(project);
  };

  const handleSendMeasurementsLink = async (project) => {
    setisSaving(true);
    try {
      const encryptedToken = sessionStorage.getItem('token');
              const token = decryptData(encryptedToken);

      const response = await fetch(`${backendApiUrl}/admin/send-collected-measurements-notification-to-customer`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        },
        body: JSON.stringify({
          projectId: project._id,
        })
      });
      const data = await response.json();
      //console.log(data);

      const statusMessages = {
        200: 'Success',
        400: 'Bad Request',
        401: 'Unauthorized',
        403: 'Forbidden',
        404: 'Not Found',
        500: 'Internal Server Error'
      };
      setNotifyPopUp(false);
      setPopupMessage(data.message || statusMessages[data.status] || 'An unexpected error occurred');
      setPopupType(data.status === 200 ? '200or201' : data.status.toString());
      setShowPopup(true);

      if (data.status === 200) {
        setTimeout(() => {
          setShowPopup(false);
          setPopupMessage('');
          setPopupType('');
        }, 2000);
      }
    } catch (error) {
      console.error('Error sending notification:', error);
      setPopupMessage('Failed to send notification');
      setPopupType('400');
      setShowPopup(true);
    }finally {
      setisSaving(false);
    }
  };

  const handleSummaryClick = (project) => {
    //console.log('Summary clicked for project:', project); 
    setSelectedProject(project);
    setShowSummaryPopup(true);
    setProductionSummary(false)
    setQuoteSummary(false)
  };


  const handleQuoteSummary = () => {
    setSelectedProject({...selectedProject, type: 'quotation'});
    setQuoteSummary(true)
    setProductionSummary(false)
  };
  
  const handleProductionSummary = () => {
    setSelectedProject({...selectedProject, type: 'production'});
    setProductionSummary(true)
    setQuoteSummary(false)
  };

/*   const handleComplete = async () => {
    if (selectedProject.type === 'production') {
      setShowOrderTypePopup(true);
    } else {
      // Original quote generation logic
      const url = `${backendApiUrl}/projects/update-project-measurements-status?projectId=${selectedProject._id}`;
      try {
        const response = await fetch(url, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'x-token': sessionStorage.getItem('token')
          },
          body: JSON.stringify({
            measurementType: selectedProject.type,
            status: 'Completed'
          })
        });
    
        if (response.ok) {
          setCompletedStatus(prev => ({
            ...prev,
            [selectedProject.type]: true
          }));
          
          setProjects(prevProjects => 
            prevProjects.map(project => 
              project._id === selectedProject._id 
                ? {
                    ...project,
                    [selectedProject.type === 'quotation' ? 'quotationMeasurementStatus' : 'productionMeasurementStatus']: 'Completed'
                  }
                : project
            )
          );
        }
      } catch (error) {
        console.error('Error updating status:', error);
      }
    }
  };


  const handleOrderTypeSelect = (type) => {
    // Handle door or window selection
    console.log(`Selected ${type} for order generation`);
    setShowOrderTypePopup(false);
    // Add your order generation logic here
  }; */
  
  const handleComplete = async () => {
    if (selectedProject.type === 'production') {
      setShowOrderTypePopup(true);
    } else {
      setShowQuoteCategoryPopup(true);
    }
  };
  
  const handleOrderTypeSelect = async (type, projectId) => {
    //console.log(`Selected ${type} for order generation with Project ID: ${projectId}`);
    
    // Call the API with production type
    await updateProjectMeasurementStatus(selectedProject._id, 'production', type);
  };

  const handleQuoteCategorySelect = async (category,type) => {
    if (!category || !selectedProject?._id) {
        console.error('Missing required parameters');
        return;
    }

    setIsGenerating(true);
    let timeoutId;

    try {
        // Set timeout to prevent infinite loading
        timeoutId = setTimeout(() => {
            setIsGenerating(false);
            throw new Error('Generation timeout exceeded');
        }, 30000); // 30 second timeout

        // Add artificial delay
        await new Promise(resolve => setTimeout(resolve, 2000));

        const result = await generatePreQuotations(selectedProject._id, category,type);
       // console.log('API Result:', result);
        if (!result) {
            throw new Error('Failed to generate pre-quotations');
        }

        clearTimeout(timeoutId);
        
        setSelectedQuoteCategory(category);
        setSelectedQuoteType(type);
        setShowQuoteCategoryPopup(false);
        setShowSummaryPopup(false);

    } catch (error) {
        console.error('Error generating quote:', error.message);
        // Reset states on error
        setSelectedQuoteCategory(null);
        setSelectedQuoteType(null);
        setShowQuoteCategoryPopup(true);
        
    } finally {
        clearTimeout(timeoutId);
        setIsGenerating(false);
    }
};


// Example of how to call the API correctly
const handleOrderCategorySelect = async (orderType) => {
  const projectId = selectedProject?._id
  try {
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);

    const response = await fetch(`${backendApiUrl}/projects/generate-order-details?projectId=${projectId}&orderType=${orderType}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token
    },
    });
    
    const result = await response.json();
    
    if (result.success) {
      // Access the orderData correctly from the response
      const orderData = result.data.orderData;
      console.log(orderData)
      setOrderData(orderData?.data);

      // Process the orderData here
    } else {
      console.error('Error fetching order details:', result.message);
    }
  } catch (error) {
    console.error('Error:', error);
  }
};



// First API: Update project measurement status
const updateProjectMeasurementStatus = async (projectId, measurementType, status) => {
  const url = `${backendApiUrl}/projects/update-project-measurements-status?projectId=${projectId}`;
  try {
        const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);

      const response = await fetch(url, {
          method: 'PUT',
          headers: {
              'Content-Type': 'application/json',
              'x-token': token
          },
          body: JSON.stringify({
              measurementType,
              status: status
          })
      });

      const data = await response.json();
      
      if (response.ok) {
          setCompletedStatus(prev => ({
              ...prev,
              [measurementType]: true
          }));

         /*  setProjects(prevProjects =>
              prevProjects.map(project =>
                  project._id === projectId
                      ? {
                          ...project,
                          [measurementType === 'quotation' ? 'quotationMeasurementStatus' : 'productionMeasurementStatus']: 'Completed'
                      }
                      : project
              )
          ); */
          fetchProjects();
          setShowSummaryPopup(false);
          setPopupMessage('Project Status Updated');
          setPopupType('200or201');
          setShowPopup(true);
          setTimeout(() => {
              setShowPopup(false);
          }, 1000);
      }
  } catch (error) {
      console.error('Error Updating Status:', error);
      setPopupMessage('Failed to update status');
      setPopupType('500');
      setShowPopup(true);
  }
};

// Second API: Generate pre-quotations
/* const generatePreQuotations = async (projectId, quoteCategory) => {
  const url = `${backendApiUrl}/projects/generate-pre-quotations`;
  
  try {
      const response = await fetch(url, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'x-token': sessionStorage.getItem('token')
          },
          body: JSON.stringify({
              projectId,
              quoteCategory
          })
      });

      const data = await response.json();
      console.log('data', data)
      if (response.status === 400) {
        console.log('data', data.message)
          setPopupMessage(data.message)
          setPopupType('400');
          setShowPopup(true);
          return;
      }

      if (response.ok) {
          if (data?.orderData) {
              setOrderData(data?.orderData?.data);
          }
          setShowSummaryPopup(false);
          setPopupMessage('Pre-quotations Generated Successfully');
          setPopupType('200or201');
          setShowPopup(true);
          setTimeout(() => {
              setShowPopup(false);
          }, 1000);
          return true;
      }
  } catch (error) {
      console.error('Error Generating Pre-quotations:', error);
      setPopupMessage('Failed to generate pre-quotations');
      setPopupType('500');
      setShowPopup(true);
  }
}; */

const generatePreQuotations = async (projectId, quoteCategory,type) => {
  const url = `${backendApiUrl}/projects/generate-pre-quotations`;
  
  try {
        const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token
      },
      body: JSON.stringify({
        projectId: projectId,
        quoteCategory: quoteCategory,
        type: type
      })
    });
    
    const data = await response.json();
    console.log('API response data:', data);
    
    if (!response.ok) {
      setPopupMessage(data.message || 'Failed to generate pre-quotations');
      setPopupType(response.status === 400 ? '400' : '500');
      setShowPopup(true);
      return false;
    }
    
    // Handle successful response
    if (data?.orderData) {
      setOrderData(data.orderData.data);
    }
    
    setShowSummaryPopup(false);
    setPopupMessage('Pre-quotations Generated Successfully');
    setPopupType('200or201');
    setShowPopup(true);
    
    setTimeout(() => {
      setShowPopup(false);
    }, 1000);
    
    return true;
    
  } catch (error) {
    console.error('Error Generating Pre-quotations:', error);
    setPopupMessage('Failed to generate pre-quotations');
    setPopupType('500');
    setShowPopup(true);
    return false;
  }
};



const handleCloseOrderPopup = () => {
  setShowOrderTypePopup(false);
  setShowSummaryPopup(false)
  setOrderData(null);
  fetchProjects();
};

const handleCloseQuoteCategoryPopup = () => {
  setShowQuoteCategoryPopup(false);
  setShowSummaryPopup(false)
  setOrderData(null);
  fetchProjects();
};

if (isLoading) {
  return <Loader />;
}

const handleExportToExcel = (orderType) => {
  if (orderData && orderData.length > 0) {
    const exportData = orderData.map(item => ({
      Name: item.window_name || item.door_name,
      'Room Name': item.room_name,
      Height: item.height,
      Width: item.width,
      Area: item.area,
      Unit: item.unit,
      Item:item.item,
      Type: item.category || item.door_type,
      'Flat Number': item.flat_number
    }));

    const fileName = `${selectedProject.projectName}_${orderData[0]?.window_name ? 'Windows' : 'Doors'}_OrderDetails.xlsx`;
    
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Order Details");
    XLSX.writeFile(wb, fileName);
  }
};


  return (
  <div className="w-full h-full flex flex-col justify-between ">
    <div className="w-full h-16 border-b flex items-center">
      <div className="flex w-full justify-between px-4 mb-4 mt-3 items-center">
        {/* New container for the title and search bar */}
        <div className="flex items-center space-x-4">
          <h1 className="text-lg font-bold">Projects</h1>
         <Search
  searchQuery={persistedSearchQuery}
  setSearchQuery={setPersistedSearchQuery}
  searchType={persistedSearchType}
  setSearchType={setPersistedSearchType}
  searchTypes={searchTypes}
  onSearch={handleSearch}
  onSearchSubmit={handleAddSearchChip}
  placeholder="Search projects..."
/>

<div className="flex flex-row items-center gap-3  whitespace-nowrap">
  {searchChips.map((chip, index) => {
    const active = chip.type === persistedSearchType;

    return (
      <div
        key={index}
        onClick={() => handleChipClick(chip)}
        className={`flex items-center px-3 py-1 rounded-full text-sm shadow-sm whitespace-nowrap ${
          active ? 'bg-red-500 text-white' : 'bg-gray-100 text-gray-800'
        }`}
      >
        <span className="font-regular">
          {chip.type}
        </span>

        <button
          className="ml-2 font-bold"
          onClick={(e) => {
            e.stopPropagation();
            handleRemoveSearchChip(chip);
          }}
        >
          ×
        </button>
      </div>
    );
  })}
</div>


        </div>

        {isRefreshing && (
          <div className="ml-2 animate-spin text-[#f7525A]">↻</div>
        )}
      




    <button
  className="bg-[#f7525a] z-20 text-white px-2 py-1 rounded"
  onClick={handleNewProject}
  data-tooltip="Create Project"
  title=" "
  style={{ '--tooltip-bg': 'black' }}
>
  <span className="md:inline hidden">+ New</span>
  <span className="md:hidden">+</span>
</button>



  </div>
</div>

<Pagination
  currentPage={currentPage}
  totalPages={totalPages}
  totalItems={totalItems}
  itemsPerPage={10}
  showInfo={true}
    hideControls={true} 
  itemName="projects"
/>

  <div className="w-full h-full bg-white rounded-xs overflow-hidden">
  <div className="overflow-y-auto h-[80vh]">
   {displayedProjects.length > 0 ? (
      <table className="w-full mb-5">
        <thead className="sticky top-0 bg-[#fafafc] text-[#6c7184] border-b">
          <tr className="border-b">
            {/* <th className="py-2 px-2 text-center text-xs sm:text-sm font-semibold cursor-pointer w-1/12">
              <div className="flex items-center justify-center" onClick={() => sortArray('projectCode')}>
                <span>Project Id</span>
                {getSortIcon('projectCode')}
              </div>
            </th> */}
            <th className="py-2 px-2 text-center text-xs sm:text-sm font-semibold cursor-pointer w-1/12">
              <div className="flex items-center justify-center" onClick={() => sortArray('projectName')}>
                <span>Project Name</span>
                {getSortIcon('projectName')}
              </div>
            </th>
            <th className="py-2 px-2 text-center text-xs sm:text-sm font-semibold cursor-pointer w-1/12">
              <div className="flex items-center justify-center" onClick={() => sortArray('builderName')}>
                <span>Builder Info</span>
                {getSortIcon('builderName')}
              </div>
            </th>

            {(roleId === '0' || roleId === '1') && (
              <th className="py-2 px-2 text-center text-xs sm:text-sm font-semibold cursor-pointer w-1/12">
                <div className="flex items-center justify-center" onClick={() => sortArray('siteContactName')}>
                  <span>Assigned MA</span>
                  {getSortIcon('siteContactName')}
                </div>
              </th>
            )}

            <th className="py-2 px-2 text-center text-xs sm:text-sm font-semibold cursor-pointer w-1/12">
              <div className="flex items-center justify-center" onClick={() => sortArray('siteContactNo')}>
                <span>Last Visit</span>
                {getSortIcon('siteContactNo')}
              </div>
            </th>

            <th className="py-2 px-2 text-center text-xs sm:text-sm font-semibold cursor-pointer w-1/12">
              <div className="flex items-center justify-center" onClick={() => sortArray('stageofconstruction')}>
                <span>Stage Of Construction</span>
                {getSortIcon('stageofconstruction')}
              </div>
            </th>

            {(roleId === '0' || roleId === '1') && (
              <>
                <th className="py-2 px-2 text-center text-xs sm:text-sm font-semibold cursor-pointer w-1/12">
                  <div className="flex items-center justify-center" onClick={() => sortArray('siteContactNo')}>
                    <span>Reshedule Date</span>
                    {getSortIcon('siteContactNo')}
                  </div>
                </th>
                <th className="py-2 px-2 text-center text-xs sm:text-sm font-semibold cursor-pointer w-1/12">
                  <div className="flex items-center justify-center" onClick={() => sortArray('siteContactName')}>
                    <span>Assigned FA</span>
                    {getSortIcon('siteContactName')}
                  </div>
                </th>
                <th className="py-2 px-2 text-center text-xs sm:text-sm font-semibold cursor-pointer w-1/12">
                  <div className="flex items-center justify-center" onClick={() => sortArray('siteContactName')}>
                    <span>FA Action</span>
                    {getSortIcon('siteContactName')}
                  </div>
                </th>
              </>
            )}

            {(roleId === '0' || sessionStorage.getItem('roleId') === '1' || roleId === '3') && (
              <>
                <th className="py-2 px-2 text-center text-xs sm:text-sm font-semibold cursor-pointer w-1/12">
                  <div className="flex items-center justify-center" onClick={() => sortArray('quoteMeasurements')}>
                    <span>Quote Measurements</span>
                    {getSortIcon('quoteMeasurements')}
                  </div>
                </th>
                <th className="py-2 px-2 text-center text-xs sm:text-sm font-semibold cursor-pointer w-1/12">
                  <div className="flex items-center justify-center" onClick={() => sortArray('productionMeasurements')}>
                    <span>Production Measurements</span>
                    {getSortIcon('productionMeasurements')}
                  </div>
                </th>
                <th className="py-2 px-2 text-center text-xs sm:text-sm font-semibold cursor-pointer w-1/12">
                  <div className="flex items-center justify-center" onClick={() => sortArray('measurements')}>
                    <span>Measurements</span>
                    {getSortIcon('measurements')}
                  </div>
                </th>
              </>
            )}

            {(roleId === '0' || roleId === '1') && (
              <th className="py-2 px-2 text-center text-xs sm:text-sm font-semibold cursor-pointer w-1/12">
                <div className="flex items-center justify-center" onClick={() => sortArray('siteContactNo')}>
                  <span>Action to Customer</span>
                  {getSortIcon('siteContactNo')}
                </div>
              </th>
            )}

            {(roleId === '0' || roleId === '1' || roleId === '3') && (
              <th className="py-2 px-2 text-center text-xs sm:text-sm font-semibold cursor-pointer w-1/12">
                <div className="flex items-center justify-center" onClick={() => sortArray('summary')}>
                  <span>Summary</span>
                  {getSortIcon('summary')}
                </div>
              </th>
            )}

            {(roleId === '2') && (
              <th className="py-2 px-2 text-center text-xs sm:text-sm font-semibold cursor-pointer w-1/12">
                <div className="flex items-center justify-center" onClick={() => sortArray('siteContactNo')}>
                  <span>Next Visit</span>
                  {getSortIcon('siteContactNo')}
                </div>
              </th>
            )}
          </tr>
        </thead>

        <tbody className="border-b border-t">
          {currentItems.length > 0 ? (
         currentItems.map((project) => {
              const date = new Date(project.timestamp);
              const formattedDate = `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()}`;

              return (
                <tr key={project._id} className="text-sm border-b">
                  {/* Project Code */}
                  {/* <td className="py-2 px-2 text-center text-sm">
                    <span
                      className="text-[#408dfb] font-500 cursor-pointer hover:underline"
                      onClick={() => handleNavigateProjectDetails(project)}
                    >
                      {project.projectCode}
                    </span>
                  </td> */}

                  {/* Project Name */}
                  <td className="py-2 px-2 text-center text-sm">
                    <span
                      className="text-[#408dfb] font-500 cursor-pointer hover:underline"
                      onClick={() => handleNavigateProjectDetails(project)}
                    >
                      {project.projectName}
                    </span>
                  </td>

                  {/* Builder Info */}
                  <td className="py-2 px-2 text-center text-sm text-gray-700">
                    <div className="flex flex-col items-center">
                      <span className="line-clamp-2 max-w-[100px]">{project.builderName}</span>
                      <a href={`tel:${project.builderContactNo}`} className="text-[#408dfb] font-500 hover:underline">
                        {project.builderContactNo}
                      </a>
                    </div>
                  </td>

                  {/* Assigned MA */}
                  {(roleId === '0' || roleId === '1') && (
                    <td
                      className="py-2 px-2 text-center text-sm text-[#408dfb] font-500 cursor-pointer hover:underline"
                      onClick={() => handleAssignMarketingAssociate(project)}
                    >
                      {project.marketingAssociateId
                        ? `${users.find((p) => p._id === project.marketingAssociateId)?.firstName} ${
                            users.find((p) => p._id === project.marketingAssociateId)?.lastName || ''
                          }`
                        : 'Unassigned User'}
                    </td>
                  )}

                  {/* Last Visit */}
                  <td className="py-2 px-2 text-center text-sm text-gray-700 whitespace-nowrap">{formattedDate}</td>

                  {/* Stage of Construction */}
                  <td className="py-2 px-2 text-center text-sm text-gray-700">{project.stageofconstruction}</td>

                  {/* Reschedule Date, FA, Action */}
                  {(roleId === '0' || roleId === '1') && (
                    <>
                      <td
                        className="py-2 px-2 text-center text-sm text-[#408dfb] font-500 cursor-pointer hover:underline"
                        onClick={() => handleOpenDate(project._id, project.rescheduleDate, project.purposeOfVisit)}
                      >
                        {project.rescheduleDate || 'Reschedule Date'}
                      </td>
                      <td
                        className="py-2 px-2 text-center text-sm text-[#408dfb] font-500 cursor-pointer hover:underline"
                        onClick={() => handleAssignFieldAssociate(project)}
                      >
                        {project.fieldAssociateId
                          ? `${users.find((p) => p._id === project.fieldAssociateId)?.firstName} ${
                              users.find((p) => p._id === project.fieldAssociateId)?.lastName || ''
                            }`
                          : 'Unassigned User'}
                      </td>
                      <td
                        className="py-2 px-2 text-center text-sm text-[#408dfb] font-500 cursor-pointer hover:underline"
                        onClick={() => handleCollect(project)}
                      >
                        Collect
                      </td>
                    </>
                  )}

                  {/* Measurements */}
                  {(roleId === '0' || roleId === '1' || roleId === '3') && (
                    <>
                      <td className="py-2 px-2 text-center text-sm text-gray-700">{project.quotationMeasurementStatus}</td>
                      <td className="py-2 px-2 text-center text-sm text-gray-700">{project.productionMeasurementStatus}</td>
                      <td className="py-2 px-2 text-center text-sm">
                        <div className="flex flex-row space-x-2 items-center justify-center">
                          <span
                            className="text-[#408dfb] font-500 cursor-pointer hover:underline"
                            onClick={() => handleNavigatetoMeasurements(project, 'quotation')}
                          >
                            Quote
                          </span>
                          <span
                            className="text-[#408dfb] font-500 cursor-pointer hover:underline"
                            onClick={() => handleNavigatetoMeasurements(project, 'production')}
                          >
                            Production
                          </span>
                        </div>
                      </td>
                    </>
                  )}

                  {/* Action to Customer */}
                  {(roleId === '0' || roleId === '1') && (
                    <td
                      className="py-2 px-2 text-center text-sm text-[#408dfb] font-500 cursor-pointer hover:underline"
                      onClick={() => handleNotify(project)}
                    >
                      Notify
                    </td>
                  )}

                  {/* Summary */}
                  {(roleId === '0' || roleId === '1' || roleId === '3') && (
                    <td
                      className="py-2 px-2 text-center text-sm text-[#408dfb] font-500 cursor-pointer hover:underline"
                      onClick={() => handleSummaryClick(project)}
                    >
                      view
                    </td>
                  )}

                  {/* Next Visit (roleId 2) */}
                  {(roleId === '2') && (
                    <td
                      className={`py-2 px-2 text-center text-sm ${
                        project.rescheduleDate && project.purposeOfVisit
                          ? 'cursor-pointer text-[#408dfb] font-500 hover:underline'
                          : 'text-gray-700'
                      }`}
                      onClick={() => {
                        if (project.rescheduleDate && project.purposeOfVisit) {
                          setSelectedPurpose(project.purposeOfVisit);
                          setShowPurposePopup(true);
                        }
                      }}
                    >
                      {project.rescheduleDate
                        ? new Date(project.rescheduleDate)
                            .toLocaleDateString('en-GB', {
                              day: '2-digit',
                              month: 'numeric',
                              year: 'numeric',
                            })
                            .replace(/\//g, '-')
                        : '--'}
                    </td>
                  )}
                </tr>
              );
            })
           ) : persistedSearchQuery ? (
          <tr>
            <td colSpan="8" className="text-center text-[#6c7184] py-4">
              <div className="flex flex-col items-center">
                <FontAwesomeIcon icon={faSearch} className="text-4xl text-gray-300 mb-4" />
                <p className="text-lg font-medium mb-2">No Results Found.</p>
                <p className="text-sm">Try adjusting your search criteria.</p>
              </div>
            </td>
          </tr>
        ) : null}
        
        </tbody>
      </table>
    ) : (
      <div className="m-4 p-4 text-center border border-grey-500 text-gray-500">
        No Projects Found.
      </div>
    )}
  </div>
</div>


             <div className="sticky bottom-0 bg-white shadow-md z-10 px-4 py-2">
<Pagination
  currentPage={currentPage}
  totalPages={totalPages}
  totalItems={totalItems}
  itemsPerPage={10}
  onPageChange={handlePageChange}
  onPreviousPage={handlePreviousPage}
  onNextPage={handleNextPage}
  showInfo={false}
  itemName="projects"
/>
</div>
{/* Pop ups */}

  {AssignMarketingAssociate && (
            <div className="fixed inset-0 flex justify-center items-center z-20 bg-black bg-opacity-50 xs:text-[12px] sm:text-[13px] md:text-[15px]">
              <div className="bg-white p-2 rounded-lg shadow-md">
                <div className="flex justify-end cursor-pointer" onClick={handleClose}>
                  <FontAwesomeIcon icon={faTimes} className="mr-2 text-red-600" />
                </div>
                <div className="w-full mx-auto mt-2">
    {/* Wrapper div with white background */}
    <div className="max-w-screen-xl mx-auto mt-3 p-2">
      <div className="flex flex-col relative rounded-md p-2 ml-10 mr-10">
        
        <table className="w-full border-b border-gray-300 mt-2">
        <thead className="border-b border-gray-300">
          <tr className="bg-[#959BB0] bg-opacity-[15%]">
            <th className="text-blue-950 text-opacity-90 py-2 px-4 text-sm text-center">User Name</th>
            <th className="text-blue-950 text-opacity-90 py-2 px-4 text-sm text-center">Mobile Number</th>
            <th className="text-blue-950 text-opacity-90 py-2 px-4 text-sm text-center">Assign User</th>
          </tr>
        </thead>
        {/* Add your table body content here */}
       
        <tbody className="border-b border-gray-300">
  {users
    .filter(user => user.roleId === 2)
    .map((User, index) => (
      <tr key={User._id} className={index % 2 === 0 ? "bg-white border-b border-gray-300" : "bg-[#F9F4F4] border-b border-gray-300"}>
        <td className="text-blue-950 text-opacity-60 py-2 text-xs px-4 text-center">{`${User.firstName} ${User.lastName}`}</td>
        <td className="text-blue-950 text-opacity-60 py-2 text-xs px-4 text-center">{User.mobileNo}</td>
        <td className="text-blue-950 text-opacity-60 py-2 text-xs px-4 text-center">
          <input
            type="checkbox"
            className="form-checkbox h-4 w-4 text-blue-500"
            checked={User._id === ProjectUserId || false}
            onChange={() => handleCheckboxChange(User._id)}
          />
        </td>
      </tr>
    ))}          
</tbody>
      </table>
      </div>
            <button class=" bg-[#0F9D58] flex flex-col relative mx-auto mt-2 text-sm text-white bg-opacity-75 rounded-sm px-4 py-1 hover:bg-opacity-90"
             onClick={handleAssignprojecttoMarketingAssociate}>Assign</button>
    </div>
    </div>
                </div>
                </div>
                )}

{AssignFieldAssociate && (
            <div className="fixed inset-0 flex justify-center items-center z-20 bg-black bg-opacity-50 xs:text-[12px] sm:text-[13px] md:text-[15px]">
              <div className="bg-white p-2 rounded-lg shadow-md">
                <div className="flex justify-end cursor-pointer" onClick={handleClose}>
                  <FontAwesomeIcon icon={faTimes} className="mr-2 text-red-600" />
                </div>
                <div className="w-full mx-auto mt-2">
    {/* Wrapper div with white background */}
    <div className="max-w-screen-xl mx-auto mt-3 p-2">
      <div className="flex flex-col relative rounded-md p-2 ml-10 mr-10">
        
        <table className="w-full border-b border-gray-300 mt-2">
        <thead className="border-b border-gray-300">
          <tr className="bg-[#959BB0] bg-opacity-[15%]">
            <th className="text-blue-950 text-opacity-90 py-2 px-4 text-sm text-center">User Name</th>
            <th className="text-blue-950 text-opacity-90 py-2 px-4 text-sm text-center">Mobile Number</th>
            <th className="text-blue-950 text-opacity-90 py-2 px-4 text-sm text-center">Assign User</th>
          </tr>
        </thead>
        {/* Add your table body content here */}
       
        <tbody className="border-b border-gray-300">
  {users
    .filter(user => user.roleId === 3)
    .map((User, index) => (
      <tr key={User._id} className={index % 2 === 0 ? "bg-white border-b border-gray-300" : "bg-[#F9F4F4] border-b border-gray-300"}>
        <td className="text-blue-950 text-opacity-60 py-2 text-xs px-4 text-center">{`${User.firstName} ${User.lastName}`}</td>
        <td className="text-blue-950 text-opacity-60 py-2 text-xs px-4 text-center">{User.mobileNo}</td>
        <td className="text-blue-950 text-opacity-60 py-2 text-xs px-4 text-center">
          <input
            type="checkbox"
            className="form-checkbox h-4 w-4 text-blue-500"
            checked={User._id === ProjectUserId || false}
            onChange={() => handleCheckboxChange(User._id)}
          />
        </td>
      </tr>
    ))}          
</tbody>
      </table>
      </div>
            <button class=" bg-[#0F9D58] flex flex-col relative mx-auto mt-2 text-sm text-white bg-opacity-75 rounded-sm px-4 py-1 hover:bg-opacity-90"
             onClick={handleAssignprojecttoFieldAssociate}>Assign</button>
    </div>
    </div>
                </div>
                </div>
                )}

  {CollectPopUp && currentProject && (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
    <div className="bg-white rounded-md shadow-md w-[500px] p-6 animate-slide-in">
        <h2 className="text-xl font-bold mb-4 text-gray-800">Notify Field Associate</h2>
        <p className="mb-4 text-gray-600">Select an action to notify the Field Associate:</p>
        <div className="space-y-3">
          <button 
            className="w-full border border-[#f7525a] hover:bg-[#f7525a] hover:text-white text-black py-2 px-4 rounded transition duration-300"
            onClick={() => handleCollectMeasurements(currentProject)}
          >
            <div className="flex items-center justify-center space-x-2">
    <span>    {currentProject.quotationMeasurementStatus === 'Completed' ? 'Re-collect Quote Measurements ' : 'Collect Quote Measurements'}
    </span>
    {isMeasurementsNotify && <Spinner />}
  </div>
          </button>
          <button 
            className="w-full border border-[#f7525a] hover:bg-[#f7525a] hover:text-white text-black  py-2 px-4 rounded transition duration-300"
            onClick={() => handleCollectAdvancePayment(currentProject)}
          >
             <div className="flex items-center justify-center space-x-2">
    <span>Collect Advance Payment</span>
    {isAdvancePaymentNotify && <Spinner />}
  </div>
          </button>
          <button 
            className="w-full border border-[#f7525a] hover:bg-[#f7525a] hover:text-white text-black  py-2 px-4 rounded transition duration-300"
            onClick={() => handleCollectProductionMeasurements(currentProject)}
          >
             <div className="flex items-center justify-center space-x-2">
  <span>  {currentProject.productionMeasurementStatus === 'Completed' ? 'Re-collect Production Measurements ' : 'Collect Production Measurements'}
    </span>
    {isProductionMeasurementsNotify && <Spinner />}
  </div>
          </button>
        </div>
        <div className='flex justify-end mt-4'>
        <button
          className={`px-2 py-1 rounded-md border ${
            isMeasurementsNotify || isAdvancePaymentNotify || isProductionMeasurementsNotify
              ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
              : 'bg-[#f5f5f5] text-gray-700 border-[#DDDDDD] hover:border-[#DDDDDD] focus:border-[#DDDDDD] focus:ring focus:ring-[#DDDDDD] focus:ring-opacity-50'
          }`}
          onClick={handleClose}
          disabled={isMeasurementsNotify || isAdvancePaymentNotify || isProductionMeasurementsNotify}
        >
          Cancel
        </button>
        </div>
      </div>
      </div>
  )}

{NotifyPopUp && currentProject && (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
    <div className="bg-white rounded-md shadow-md w-[500px] p-6 animate-slide-in">
        <h2 className="text-xl font-bold mb-4 text-gray-800">Notify Customer</h2>
        <p className="mb-4 text-gray-600">Select an action to notify the Customer:</p>
        <div className="space-y-3">
          <button 
            className="w-full border border-[#f7525a] hover:bg-[#f7525a] hover:text-white text-black py-2 px-4 rounded transition duration-300"
            onClick={() => handleSendMeasurementsLink(currentProject)}
          >
            <div className="flex items-center justify-center space-x-2">
    <span>Send Quotations</span>
    {isSaving && <Spinner />}
  </div>
          </button>
        </div>
        <div className='flex justify-end mt-4'>
        <button
          className={`px-2 py-1 rounded-md border ${
            isSaving
              ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
              : 'bg-[#f5f5f5] text-gray-700 border-[#DDDDDD] hover:border-[#DDDDDD] focus:border-[#DDDDDD] focus:ring focus:ring-[#DDDDDD] focus:ring-opacity-50'
          }`}
          onClick={handleClose}
          disabled={isSaving}
        >
          Cancel
        </button>
        </div>
      </div>
      </div>
  )}
                {UserAssignedtoProjectAlert && (
    <div className="fixed inset-0 z-30 flex items-center justify-center">
    {/* Background overlay (blurred) */}
    <div className="absolute inset-0 bg-black opacity-30 "></div>
  
    <div className="bg-white p-4 rounded-md shadow-md relative z-10 flex flex-col items-center justify-center">
    <p className="text-lg font-bold mb-2">
       User assigned to project successfully!</p>
       <button className="items-center justify-center text-white bg-green-600 hover:bg-green-700 py-1 px-2 rounded-md mt-4" onClick={handleUserAssignedtoProjectAlert}>OK</button>
      </div>
    </div>
  )} 

{DatePopup  && (
  <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
    <div className="bg-white rounded-md shadow-md w-[500px] p-6 animate-slide-in">
      <div className="flex justify-end cursor-pointer absolute top-2 right-2" onClick={handleCloseDate}>
        <FontAwesomeIcon icon={faTimes} className="text-red-600" />
      </div>
      <h2 className="text-xl font-semibold mb-4">Reschedule Marketing Associate Visit</h2>
      <div className="space-y-4">
        <div className="flex items-center space-x-4">
          <label htmlFor="rescheduleDate" className="text-sm font-medium w-1/3">Reschedule Date:</label>
          <input
            type="date"
            id="rescheduleDate"
            className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={date}
            onChange={handleDateChange}
          />
        </div>
        <div className="flex space-x-4">
          <label htmlFor="purposeOfVisit" className="text-sm font-medium w-1/3">Purpose of Visit:</label>
          <textarea
            id="purposeOfVisit"
            className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
            value={purposeOfVisit}
            onChange={handlePurposeChange}
            placeholder="Enter purpose of visit"
            rows="3"
          ></textarea>
        </div>
      </div>
      <div className='flex justify-start mt-4 '>
      <button
        className=" border border-[#f7525a] hover:bg-[#f7525a] hover:text-white text-black text-sm px-2 py-1 rounded-md hover:bg-opacity-90 transition duration-300"
        onClick={handleSubmit}
      >
        <div className="flex items-center justify-center space-x-2">
       <span> Submit</span>
        {isSaving && <Spinner />}
        </div>
      </button>
        <button  onClick={handleCloseDate}   className={`ml-2 hover:border-[#DDDDDD] focus:border-[#DDDDDD] focus:ring focus:ring-[#DDDDDD] focus:ring-opacity-50 px-2 py-1 rounded-md ${
          isSaving ? 'bg-gray-400 text-gray-500 cursor-not-allowed' : 'bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD]'
        }`}
         disabled={isSaving} >Cancel</button>
        </div>
    </div>
  </div>
)}

    {noSelectAssignUseralert &&(
         <div className="fixed inset-0 z-30 flex items-center justify-center">
         {/* Background overlay (blurred) */}
         <div className="absolute inset-0 bg-black opacity-30 "></div>
  
         <div className="bg-white p-4 rounded-md shadow-md relative z-10 flex flex-col items-center justify-center">
         <p className="text-lg font-bold mb-2">
           Please select at least one user!
           </p>
           <button className="items-center justify-center text-white bg-green-600 hover:bg-green-700 py-1 px-2 rounded-md mt-4" onClick={ handleClosenoAssigneUser}>
             OK
           </button>
         </div>
       </div>
        )}

{showSummaryPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
    <div className="bg-white p-4 rounded-lg max-w-4xl max-h-[90vh] overflow-y-auto relative">
    <button
        className="absolute top-2 right-2 bg-transparent text-gray-600 hover:text-gray-800"
        onClick={() => setShowSummaryPopup(false)}
      >
        <FontAwesomeIcon icon={faTimes} />
      </button>
            <h2 className="text-lg font-bold mb-4">Summary Options</h2>
            <div className="flex space-x-4 mb-4">
              <button 
                className={`border border-[#EB001B] hover:bg-[#EB001B] hover:text-white text-md rounded-sm px-4 py-1  mb-4 ${quoteSummary? 'bg-[#EB001B] text-white' :''}`}
                onClick={handleQuoteSummary}
              >
                Quote Summary
              </button>
              <button 
                className={`border border-[#EB001B] hover:bg-[#EB001B] hover:text-white text-md rounded-sm px-4 py-1  mb-4 ${productionSummary? 'bg-[#EB001B] text-white' :''}`}
                onClick={handleProductionSummary}
              >
                Production Summary
              </button>
            </div>
            <div className="mt-4">
  {selectedProject && selectedProject.type && (
    <ProjectReports project={selectedProject} type={selectedProject.type} />
  )}
{selectedProject && selectedProject.type && (
  <div className="flex justify-center mt-4">
    {(roleId === '0' || roleId === '1') ? (
      <>
        {selectedProject.type === 'quotation' ? (
          <button
            className="border border-[#EB001B] hover:bg-[#EB001B] hover:text-white text-md rounded-sm px-4 py-1 mb-4 mr-2"
            onClick={handleComplete}
          >
            Generate Quotes
          </button>
        ) : (
          <button
            className="border border-[#EB001B] hover:bg-[#EB001B] hover:text-white text-md rounded-sm px-4 py-1 mb-4 mr-2"
            onClick={handleComplete}
          >
            Generate Order Details
          </button>
        )}

        {/* Conditional button for roles 0 and 1 */}
        {
  (
    (selectedProject.type === 'quotation' && selectedProject.quotationMeasurementStatus === 'Completed') ||
    (selectedProject.type === 'production' && selectedProject.productionMeasurementStatus === 'Completed')
  ) ? (
    <button
      className="border border-[#EB001B] hover:bg-[#EB001B] hover:text-white text-md rounded-sm px-4 py-1 mb-4"
      onClick={() => updateProjectMeasurementStatus(selectedProject._id, selectedProject.type, 'Pending')}
    >
      Revoke Status
    </button>
  ) : (
    <button
      className={`border border-[#EB001B] hover:bg-[#EB001B] hover:text-white text-md rounded-sm px-4 py-1 mb-4
                 ${(selectedProject.type === 'quotation' && selectedProject.quotationMeasurementStatus === 'Completed') ||
                   (selectedProject.type === 'production' && selectedProject.productionMeasurementStatus === 'Completed')
                    ? 'cursor-not-allowed bg-gray-300' : ''}`}
      onClick={() => {
        if (
          (selectedProject.type === 'quotation' && selectedProject.quotationMeasurementStatus !== 'Completed') ||
          (selectedProject.type === 'production' && selectedProject.productionMeasurementStatus !== 'Completed')
        ) {
          updateProjectMeasurementStatus(selectedProject._id, selectedProject.type, 'Completed');
        }
      }}
    >
      {(selectedProject.type === 'quotation' && selectedProject.quotationMeasurementStatus === 'Completed') ||
       (selectedProject.type === 'production' && selectedProject.productionMeasurementStatus === 'Completed')
        ? 'Completed' : 'Complete'}
    </button>
  )
}


      </>
   ) : roleId === '3' ? (
    // Conditional button for role 3
    <button
      className={`border border-[#EB001B] hover:bg-[#EB001B] hover:text-white text-md rounded-sm px-4 py-1 mb-4
                 ${(selectedProject.type === 'quotation' && selectedProject.quotationMeasurementStatus === 'Completed') ||
                   (selectedProject.type === 'production' && selectedProject.productionMeasurementStatus === 'Completed')
                    ? 'cursor-not-allowed bg-gray-300' : ''}`}
      onClick={() => {
        if (
          (selectedProject.type === 'quotation' && selectedProject.quotationMeasurementStatus !== 'Completed') ||
          (selectedProject.type === 'production' && selectedProject.productionMeasurementStatus !== 'Completed')
        ) {
          updateProjectMeasurementStatus(selectedProject._id, selectedProject.type, 'Completed');
        }
      }}
    >
      {(selectedProject.type === 'quotation' && selectedProject.quotationMeasurementStatus === 'Completed') ||
       (selectedProject.type === 'production' && selectedProject.productionMeasurementStatus === 'Completed')
        ? 'Completed' : 'Complete'}
    </button>
  ) : null}
  
  
  </div>
)}







{showQuoteCategoryPopup && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-40">
    <div className="bg-white p-6 rounded-lg shadow-md w-96">

      {/* Quote Type Section */}
      <h2 className="text-xl font-bold mb-4">Select Quote Type</h2>

      <div className="space-y-3 mb-6">
        <div>Unitwise Will be Available Soon</div>
{/*         <label className="flex items-center space-x-2 cursor-pointer">
          <input
            type="radio"
            name="quoteType"
            value="unitwise"
            checked={selectedQuoteType === 'unitwise'}
            onChange={(e) => setSelectedQuoteType(e.target.value)}
            className="form-radio"
          />
          <span>Unitwise</span>
        </label> */}
        <label className="flex items-center space-x-2 cursor-pointer">
          <input
            type="radio"
            name="quoteType"
            value="whole_project"
            checked={selectedQuoteType === 'whole_project'}
            onChange={(e) => setSelectedQuoteType(e.target.value)}
            className="form-radio"
          />
          <span>Whole Project</span>
        </label>
      </div>

      <h2 className="text-xl font-bold mb-4">Select Quote Category</h2>
      <div className="space-y-3">
        <label className="flex items-center space-x-2 cursor-pointer">
          <input
            type="radio"
            name="quoteCategory"
            value="all"
            checked={selectedQuoteCategory === 'all'}
            onChange={(e) => setSelectedQuoteCategory(e.target.value)}
            className="form-radio"
          />
          <span>All</span>
        </label>
        <label className="flex items-center space-x-2 cursor-pointer">
          <input
            type="radio"
            name="quoteCategory"
            value="tiles"
            checked={selectedQuoteCategory === 'tiles'}
            onChange={(e) => setSelectedQuoteCategory(e.target.value)}
            className="form-radio"
          />
          <span>Tiles</span>
        </label>
        <label className="flex items-center space-x-2 cursor-pointer">
          <input
            type="radio"
            name="quoteCategory"
            value="windows"
            checked={selectedQuoteCategory === 'windows'}
            onChange={(e) => setSelectedQuoteCategory(e.target.value)}
            className="form-radio"
          />
          <span>Windows</span>
        </label>
        <label className="flex items-center space-x-2 cursor-pointer">
          <input
            type="radio"
            name="quoteCategory"
            value="doors"
            checked={selectedQuoteCategory === 'doors'}
            onChange={(e) => setSelectedQuoteCategory(e.target.value)}
            className="form-radio"
          />
          <span>Doors</span>
        </label>
      </div>
      <div className="mt-4 flex justify-end space-x-2">
        <button
          className="px-4 py-2 bg-gray-200 rounded-md"
          onClick={handleCloseQuoteCategoryPopup}
        >
          Cancel
        </button>
        <button
          className="px-4 py-2 bg-[#EB001B] text-white rounded-md hover:bg-opacity-90"
          onClick={() => handleQuoteCategorySelect(selectedQuoteCategory,selectedQuoteType)}
          disabled={isGenerating}
        >
          <div className="flex items-center justify-center space-x-2">
            <span>Save</span>
          </div>
        </button>
      </div>
    </div>
    {isGenerating && (
      <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
        <div className="bg-white p-8 rounded-lg flex flex-col items-center">
          <div className="w-16 h-16 border-4 border-gray-200 border-t-[#EB001B] rounded-full animate-spin mb-4"></div>
          <p className="text-lg font-medium text-gray-800">Generating Quote...</p>
        </div>
      </div>
    )}
  </div>
)}




{showOrderTypePopup && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white p-4 rounded-lg max-w-4xl max-h-[90vh] overflow-y-auto relative">
      <button
        className="absolute top-2 right-2 bg-transparent text-gray-600 hover:text-gray-800"
        onClick={handleCloseOrderPopup}
        >
        <FontAwesomeIcon icon={faTimes} />
      </button>
      <h2 className="text-xl font-bold mb-4">Select Order Type</h2>

      <div className="flex space-x-4 mt-4">
  {orderData && orderData.length > 0 && (
    <button
      className="bg-green-500 text-white px-3 py-1 rounded-sm hover:bg-green-600 ml-auto"
      onClick={handleExportToExcel}
    >
      Export
    </button>
  )}
</div>

<div className="flex space-x-4 mb-4">
        <button
          className="border border-[#EB001B] hover:bg-[#EB001B] hover:text-white text-md rounded-sm px-6 py-2 relative disabled:opacity-50"
          onClick={() => handleOrderCategorySelect('doors')}
          disabled={isSaving}
        >
          <div className="flex items-center justify-center space-x-2">
            <span>Doors</span>
            {isSaving && <Spinner />}
          </div>
        </button>
        <button
          className="border border-[#EB001B] hover:bg-[#EB001B] hover:text-white text-md rounded-sm px-6 py-2 relative disabled:opacity-50"
          onClick={() => handleOrderCategorySelect('windows')}
          disabled={isSaving}
        >
          <div className="flex items-center justify-center space-x-2">
            <span>Windows</span>
            {isSaving && <Spinner />}
          </div>
        </button>
      </div>
      
      {orderData && (
        orderData.length > 0 ? (
          <div className="overflow-x-auto mt-4">
            <table className="min-w-full bg-white border border-gray-300">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-2 border">Name</th>
                  <th className="px-4 py-2 border">Room Name</th>
                  <th className="px-4 py-2 border">Height</th>
                  <th className="px-4 py-2 border">Width</th>
                  <th className="px-4 py-2 border">Area</th>
                  <th className="px-4 py-2 border">Unit</th>
                  <th className="px-4 py-2 border">Item</th>
                  <th className="px-4 py-2 border">
                    {orderData[0]?.window_name ? 'Window Type' : 'Door Type'}
                  </th>
                  <th className="px-4 py-2 border">Flat Number</th>
                </tr>
              </thead>
              <tbody>
                {orderData.map((item, index) => (
                  <tr key={index} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                    <td className="px-4 py-2 border">{item.window_name || item.door_name}</td>
                    <td className="px-4 py-2 border">{item.room_name}</td>
                    <td className="px-4 py-2 border">{item.height}</td>
                    <td className="px-4 py-2 border">{item.width}</td>
                    <td className="px-4 py-2 border">{item.area}</td>
                    <td className="px-4 py-2 border">{item.unit}</td>
                    <th className="px-4 py-2 border">{item.item}</th>
                    <td className="px-4 py-2 border">{item.category || item.door_type}</td>
                    <td className="px-4 py-2 border">{item.flat_number}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="text-center py-4 text-gray-600">No order data available</p>
        )
      )}
    </div>
  </div>
)}




</div>
          </div>
        </div>
      )}
        


  {showPopup && (
  <div>
    {popupType === '200or201' && <Msg200or201 message={popupMessage} timeout={3000} />}
    {popupType === '204' && <Msg204 message={popupMessage} timeout={3000} />}
    {popupType === '400' && <Msg400 message={popupMessage} closePopup={closePopup} />}
          {popupType === '401' && <Msg401 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '403' && <Msg403 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '500' && <Msg500 message={popupMessage} closePopup={Retry} cancelPopup={closePopup} />}
  </div>
)}

{/* Pop ups */}
  </div>
);
};

export default ProjectList;